import React from 'react';
import { connect } from 'react-redux';
import Category from './item';
import './styles.css';

const Catalog = ({
  category
}) => {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '1'
  }
  const keys = Object.keys(category);
  return (
    <div style={style}>
      {
        keys.map(key => {
          return (
            <Category categoryGuid={key} key={key} category={category} />
          );
        })
      }
    </div>
  );
}

export default connect(
  state => ({ category: state.category})
)(Catalog);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/category/list.js